import { render, staticRenderFns } from "./scStreamingWidget.vue?vue&type=template&id=85b8df1e&scoped=true&"
import script from "./scStreamingWidget.vue?vue&type=script&lang=js&"
export * from "./scStreamingWidget.vue?vue&type=script&lang=js&"
import style0 from "./scStreamingWidget.vue?vue&type=style&index=0&id=85b8df1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b8df1e",
  null
  
)

export default component.exports